import { render, staticRenderFns } from "./TermAgreement.vue?vue&type=template&id=09d7b844&scoped=true&"
import script from "./TermAgreement.vue?vue&type=script&lang=js&"
export * from "./TermAgreement.vue?vue&type=script&lang=js&"
import style0 from "./TermAgreement.vue?vue&type=style&index=0&id=09d7b844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d7b844",
  null
  
)

export default component.exports